import React, { useState } from 'react';
import { Box, Button, Stack, TextField, Typography, Alert } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const EXPECTED = (process.env.REACT_APP_GATE_PASSWORD || '').trim(); // set in your env
const STORAGE_KEY = 'st_authed';

export default function PasswordPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: Location } };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!EXPECTED) {
      setError('Password not configured. Set REACT_APP_GATE_PASSWORD.');
      return;
    }
    if (password === EXPECTED) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      const dest = location.state?.from?.pathname || '/app';
      navigate(dest, { replace: true });
    } else {
      setError('Incorrect password. Try again.');
    }
  };

  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 420 }}>
        <Stack spacing={2}>
          <Typography variant="h4" component="h1" textAlign="center">Enter Password</Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            fullWidth
          />
          <Button type="submit" variant="contained" size="large">Unlock</Button>
        </Stack>
      </Box>
    </Box>
  );
}

export function isAuthed() {
  return sessionStorage.getItem('st_authed') === 'true';
}
